import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { DailogBox } from "../../../../../components/Elements/DailogBox/DailogBox";
import { createLocation } from "../../../../../redux/customer/customerSlice";
import PopupCard from "../../../../../components/Cards/PopupCard/PopupCard";
import { states } from "../../../../../utils/schema/states";
import { useParams } from "react-router-dom";
import axios from "axios";
const AddLocation = ({ onOpen, onClose }) => {
  const dispatch = useDispatch();
const { userId } = useParams();
  const [formData, setFormData] = useState({
    name: "",
    location_type: "",
    other_type: "",
    country: "",
    state: "",
    city: "",
    address: "",
    status: "Active",
  });
  const [successPopup, setSuccessPopup] = useState({
    visible: false,
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [cities, setCities] = useState([]);
  // handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  //GET CITIES
  const fetchCities = async (stateCode) => {
    try {
      if (!stateCode) {
        setCities([]);
        return;
      }

      const res = await axios.get(
        `https://api.countrystatecity.in/v1/countries/IN/states/${stateCode}/cities`,
        {
          headers: {
            "X-CSCAPI-KEY":
              "0ae5a8283890022255b0058d88f4397ecde12b3253eae7c2af2ef157c23f108b",
          },
        },
      );

      setCities(res.data);
    } catch (err) {
      console.error("City fetch failed", err);
      setCities([]);
    }
  };
  // validation
  const validate = () => {
    let newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Location name is required";

    if (!formData.location_type) {
      newErrors.location_type = "Location type is required";
    } else if (
      formData.location_type === "Other" &&
      !formData.other_type.trim()
    ) {
      newErrors.other_type = "Please specify the location type";
    }

    if (!formData.country.trim()) newErrors.country = "Country is required";

    if (!formData.state.trim()) newErrors.state = "State is required";

    if (!formData.city.trim()) newErrors.city = "City is required";

    if (!formData.address.trim()) newErrors.address = "Address is required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // save function

  const handleSave = async () => {
    if (!validate()) return;

    try {
      const typeToSave =
        formData.location_type === "Other"
          ? formData.other_type
          : formData.location_type;
      const payload = {
        ...formData,
        location_type: typeToSave,
      };
      const res = await dispatch(
        createLocation({ userId, formData: payload }),
      ).unwrap();

      setSuccessPopup({
        visible: true,
        message: res.message,
      });

      setTimeout(() => {
        setSuccessPopup({ visible: false, message: "" });
        onClose();
      }, 3000);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Location Name */}
            <div>
              <label className="text-sm text-[#06513D]">Location Name</label>
              <input
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full mt-1 border border-[#3BA2B959] rounded-md px-3 py-2 outline-none"
              />
              {errors.name && (
                <p className="text-red-500 text-xs mt-1">{errors.name}</p>
              )}
            </div>

            {/* Location Type */}
            <div>
              <label className="text-sm text-[#06513D]">Location Type</label>
              <select
                name="location_type"
                value={formData.location_type}
                onChange={handleChange}
                className="w-full mt-1 border border-[#3BA2B959] rounded-md px-3 py-2 outline-none"
              >
                <option value="">Select Type</option>
                <option value="Office">Office</option>
                <option value="Warehouse">Warehouse</option>
                <option value="Factory">Factory</option>
                <option value="Other">Other</option>
              </select>
              {errors.location_type && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.location_type}
                </p>
              )}
            </div>

            {/* Country */}
            <div>
              <label className="text-sm text-[#06513D]">Country</label>
              <input
                name="country"
                value={formData.country}
                onChange={handleChange}
                className="w-full mt-1 border border-[#3BA2B959] rounded-md px-3 py-2 outline-none"
              />
              {errors.country && (
                <p className="text-red-500 text-xs mt-1">{errors.country}</p>
              )}
            </div>

            {/* State */}
            <div>
              <label className="text-sm text-[#06513D]">State</label>
              <select
                name="state"
                value={formData.stateCode}
                onChange={(e) => {
                  const selectedState = states.find(
                    (s) => s.code === e.target.value,
                  );

                  setFormData((prev) => ({
                    ...prev,
                    state: selectedState?.name || "", // store name
                    stateCode: selectedState?.code || "", // store code
                    city: "",
                  }));

                  fetchCities(e.target.value); // still use code
                }}
                className="w-full mt-1 border border-[#3BA2B959] rounded-md px-3 py-2 outline-none"
              >
                <option value="">Select State</option>

                {states.map((state) => (
                  <option key={state.id} value={state.code}>
                    {state.name}
                  </option>
                ))}
              </select>
              {errors.state && (
                <p className="text-red-500 text-xs mt-1">{errors.state}</p>
              )}
            </div>

            {/* City */}
            <div>
              <label className="text-sm text-[#06513D]">City</label>
              <select
                name="city"
                value={formData.city}
                onChange={handleChange}
                className="w-full mt-1 border border-[#3BA2B959] rounded-md px-3 py-2 outline-none"
              >
                <option value="">Select City</option>

                {cities.map((city, index) => (
                  <option key={index} value={city.name}>
                    {city.name}
                  </option>
                ))}
              </select>
              {errors.city && (
                <p className="text-red-500 text-xs mt-1">{errors.city}</p>
              )}
            </div>

            {/* Address */}
            <div>
              <label className="text-sm text-[#06513D]">Address</label>
              <input
                name="address"
                value={formData.address}
                onChange={handleChange}
                className="w-full mt-1 border border-[#3BA2B959] rounded-md px-3 py-2 outline-none"
              />
              {errors.address && (
                <p className="text-red-500 text-xs mt-1">{errors.address}</p>
              )}
            </div>
            <div>
              <label className="text-sm text-[#06513D]">Status</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="w-full mt-1 border border-[#3BA2B959] rounded-md px-3 py-2 outline-none"
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
            {/* Custom Type (Parallel to Status if visible) */}
            {formData.location_type === "Other" ? (
              <div>
                <label className="text-sm text-[#06513D]">Specify Type</label>
                <input
                  type="text"
                  name="other_type"
                  value={formData.other_type}
                  onChange={handleChange}
                  placeholder="Enter location type"
                  className="w-full mt-1 border border-[#3BA2B959] rounded-md px-3 py-2 outline-none animate-fadeIn"
                />
                {errors.other_type && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.other_type}
                  </p>
                )}
              </div>
            ) : (
              <div className="hidden md:block"></div>
            )}

            {/* Status */}
          </div>

          {/* Buttons */}
          <div className="flex justify-center gap-4 mt-6">
            <button
              onClick={onClose}
              className="px-6 py-2 border border-[#06513D] text-[#06513D] rounded-md"
            >
              Cancel
            </button>

            <button
              onClick={handleSave}
              className="px-6 py-2 bg-[#06513D] text-white rounded-md"
            >
              Add Details
            </button>
          </div>
        </div>
      </DailogBox>
      {successPopup.visible && (
        <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center">
          <PopupCard
            type="success"
            title="Success"
            message={successPopup.message}
          />
        </div>
      )}
    </div>
  );
};

export default AddLocation;
